import { c as _c } from "react/compiler-runtime";
import { runtimeConfig } from "@src/runtime-config";
import { Dialog, ExperimentalIcon, IconButton, Tooltip, NO_TRANSLATE_CLASS, Text } from "@flat-ui";
import { useState } from "react";
import { currentUserSelector } from "@store/user/user-selector";
import { useAppSelector } from "@store/store-helper";
import { EmailUtils, RuntimeUtils } from "@stellar/utils";
import { DevFeaturesDialogContent } from "@components/dev-features-dialog/dev-features-dialog-content";
import { Box } from "@mui-wrapper";
import { appStateSelector } from "@store/app/app-selector";
import { shouldShowDevFeaturesButton } from "@components/dev-features-dialog/features-utils";
const isProduction = RuntimeUtils.isProductionEnvironment(runtimeConfig.appEnv);

/**
 * Icon button to open the dialog for development features.
 * @returns An icon button opening the dev features dialog
 */
export function DevFeaturesDialogButton() {
  const $ = _c(12);
  const [isOpen, setIsMenuOpen] = useState(false);
  const currentUser = useAppSelector(currentUserSelector);
  const isInternalUser = EmailUtils.isInternalUser(currentUser?.email ?? "");
  const {
    isDevModeEnabled,
    isAlphaTestingEnabled,
    isBetaTestingEnabled
  } = useAppSelector(appStateSelector);
  if (!shouldShowDevFeaturesButton({
    isProduction,
    isInternalUser,
    isDevModeEnabled,
    isAlphaTestingEnabled,
    isBetaTestingEnabled
  })) {
    return null;
  }
  let t0;
  if ($[0] !== isOpen) {
    t0 = () => setIsMenuOpen(!isOpen);
    $[0] = isOpen;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ExperimentalIcon />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <Tooltip title="Experimental features" className={NO_TRANSLATE_CLASS}><IconButton onClick={t0}>{t1}</IconButton></Tooltip>;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsMenuOpen(false);
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Box><Text variant="bodyM" sx={{
        display: "block",
        color: "text.secondary",
        my: 2,
        mt: 0
      }}>Debug and test the app with the following tools/features.</Text><DevFeaturesDialogContent /></Box>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== isOpen) {
    t5 = <Dialog title="Experimental Features" open={isOpen} onClose={t3} size="l">{t4}</Dialog>;
    $[7] = isOpen;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t2 || $[10] !== t5) {
    t6 = <Box component="div">{t2}{t5}</Box>;
    $[9] = t2;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}